import { useState, } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { NSARouterMaker, NSARouterMakerProps } from "namirasoft-account-react";
import { NamirasoftEmailSenderServer } from "namirasoft-email-sender";
import { EnvService, IStorageSession } from 'namirasoft-core'
import { NSNotFoundPage } from "namirasoft-site-react";
import { EmailSenderRoutes } from "./EmailSenderRoutes";
//pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SentListPage from "./pages/SentListPage";
import SendPage from "./pages/SendPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";

export default function Router()
{
    let [state, setState] = useState<number>(Math.random());

    let location = useLocation();
    let navigate = useNavigate();

    let maker = new NSARouterMaker(new IStorageSession(), () => { setState(state + Math.random()); }, {
        onRenderOnLogin: (props: NSARouterMakerProps) =>
        {
            let DOMAIN_EMAIL_SENDER = new EnvService("REACT_APP_BASE_URL_EMAIL_SENDER", true).getString();
            let email_sender = new NamirasoftEmailSenderServer(DOMAIN_EMAIL_SENDER, props.account.token_manager, props.notifier.onError);
            return (
                <Routes>
                    <Route path={EmailSenderRoutes.Home} element={<HomePage {...props} />} />
                    <Route path={EmailSenderRoutes.ProviderList} element={<ProviderListPage {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.ProviderNew} element={<ProviderEditPage isEdit={false} {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage isEdit={false} {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage isEdit={true} {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.SentList} element={<SentListPage {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.Send(null)} element={<SendPage {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.Send(":id")} element={<SendPage {...props} servers={{ email_sender }} />} />
                    <Route path={EmailSenderRoutes.Verify(":provider_id")} element={<VerifyEmailPage {...props} servers={{ email_sender }} />} />
                    <Route path="*" element={<NSNotFoundPage />} />
                </Routes>
            );
        },
        onRenderOnLogout: () =>
        {
            return (
                <Routes>
                    <Route path={EmailSenderRoutes.Home} element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            );
        }
    }, location, navigate)

    return maker.onRender();
}